import { useQuery } from "@tanstack/react-query";
import { fetchPodcastList } from "../services/podcastService";

function normalizePodcast(item = {}, index = 0) {
  return {
    id: Number(item?.audio_podcast_id || item?.podcast_id || item?.id || index + 1),
    serialNo: Number(item?.podcast_index || index + 1),
    title: item?.podcast_name || item?.name || "Podcast will be available soon.",
    description: item?.description || "",
    freePaid: String(item?.free_paid || "F").toUpperCase(),
    paymentStatus: Number(item?.payment_status || 0),
    isBookmarked: Number(item?.bookmark_status || 0) === 1,
    isLiked: Number(item?.like_status || 0) === 1,
    isRead: Number(item?.is_podcast_read || 0) === 1,
    viewLabel: item?.podcast_view_at || "",
    viewCount: Number(item?.total_views || 0),
    notesCount: Number(item?.total_notes || 0),
    likeCount: Number(item?.total_liked || 0),
    subscriptionMessage: item?.subscription_message || "",
    raw: item,
  };
}

export function usePodcastList(params = {}, options = {}) {
  return useQuery({
    queryKey: ["podcastList", params],
    queryFn: async () => {
      const { payload } = await fetchPodcastList(params);
      const pagination = payload?.pagination || {};
      return {
        stateName: payload?.state_name || "",
        subjectName: payload?.subject_name || "",
        topicName: payload?.topic_name || "",
        totalPodcasts: Number(payload?.total_podcasts || 0),
        advertEarnedCoins: Number(payload?.advert_earned_coins || 0),
        podcasts: (Array.isArray(payload?.podcast_list) ? payload.podcast_list : []).map(normalizePodcast),
        pagination: { currentPage: Number(pagination?.currentPage || 1), totalPages: Number(pagination?.totalPages || 1), totalRecords: Number(pagination?.totalRecords || 0) },
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) => previousData ?? { stateName: "", subjectName: "", topicName: "", totalPodcasts: 0, advertEarnedCoins: 0, podcasts: [], pagination: { currentPage: 1, totalPages: 1, totalRecords: 0 } },
  });
}
